import React from 'react';

export default ({ children })=> (
	<div className='Main'>
		{ children }
	</div>
)